import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { MyFundDocumentsState, MyFundDocumentsTypes } from './types';

export const initialState: MyFundDocumentsState = {
    status: HttpRequestStatus.NOOP,
    fundDocuments: undefined,
    error: undefined
};

const reducer: Reducer<MyFundDocumentsState> = (state = initialState, action): MyFundDocumentsState => {
    switch (action.type) {
        case MyFundDocumentsTypes.MY_FUND_DOCUMENTS_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, error: undefined };
        }
        case MyFundDocumentsTypes.MY_FUND_DOCUMENTS_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, fundDocuments: action.payload, error: undefined };
        }
        case MyFundDocumentsTypes.MY_FUND_DOCUMENTS_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case MyFundDocumentsTypes.MY_FUND_DOCUMENTS_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as myFundDocumentsReducer };
